import Alert from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

export const Error = () => {
  const { t } = useTranslation("errors");
  return <Alert severity={"error"}>{t("internal_error")}.</Alert>;
};
